import querystring from 'querystring'
import { ServicesInfo } from '@feedyou/utils'
import { BotId } from '@feedyou-ai/feedbot-schema'
import { CloudServiceSource } from '@feedyou/utils'

import { serverApi, ServerApiTag } from '../../store/serverApi'

export const cloudServicesApi = serverApi.injectEndpoints({
  endpoints: builder => ({
    getCloudServices: builder.query<ServicesInfo, { botId: BotId; source: CloudServiceSource }>({
      query: ({ botId, source }) => ({
        url: `/bots/${botId}/cloud-services?` + querystring.stringify({ source })
      }),
      providesTags: [ServerApiTag.CLOUD_SERVICES]
    })
  })
})
